import { render, staticRenderFns } from "./Embeds.vue?vue&type=template&id=985cabb4&"
import script from "./Embeds.vue?vue&type=script&lang=js&"
export * from "./Embeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports